// import { useState, useEffect } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Container,
//   CircularProgress,
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ErrorIcon from "@mui/icons-material/Error";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from "@mui/material";

// export default function ServiceStatus() {
//   const [status, setStatus] = useState("checking");
//   const [services, setServices] = useState([]);

//   const apiUrls = [
//     "https://api.unify.care/api/workos/health",
//     "https://api.unify.care/api/account/health",
//     "https://api.unify.care/api/administration/health",
//     "https://api.unify.care/api/order/health",
//     "https://api.unify.care/api/diagnostic/health",
//     "https://api.unify.care/api/fhir/health",
//     "https://api.unify.care/api/billing/health",
//     "https://api.unify.care/api/payment/health",
//     "https://api.unify.care/api/ipd/health",
//     "https://api.unify.care/api/pharmacy/health",
//     "https://api.unify.care/api/translation/health",
//     "https://api.unify.care/api/abdm/health",
//     "https://api.unify.care/api/studio/health",
//     "https://api.unify.care/api/healtharticle/health",
//   ];

//   const msgObj = {
//     checking: {
//       message: "Checking services...",
//       color: "#fbc02d",
//     },
//     success: {
//       message: "Environment is stable",
//       color: "#19706e",
//     },
//     failure: {
//       message: "Environment is not stable",
//       color: "#d32f2f",
//     },
//   };

//   const checkServices = async () => {
//     try {
//       const results = await Promise.allSettled(
//         apiUrls.map(async (url) => {
//           const res = await fetch(url, { cache: "no-store" });
//           return { name: url.split("/")[4], status: res.status === 200 };
//         })
//       );

//       const serviceData = results.map((result, index) =>
//         result.status === "fulfilled"
//           ? result.value
//           : { name: apiUrls[index].split("/")[4], status: false }
//       );

//       const runningServices = serviceData.filter((s) => s.status).length;
//       setServices(serviceData);
//       setStatus(runningServices === apiUrls.length ? "success" : "failure");
//     } catch (error) {
//       setStatus("failure");
//     }
//   };

//   useEffect(() => {
//     checkServices();

//     const interval = setInterval(() => {
//       checkServices();
//     }, 600000);

//     return () => clearInterval(interval);
//   }, []);

//   const failedServices = services.filter((s) => !s.status);

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         minHeight: "100vh",
//         backgroundColor: "#f4f6f8",
//       }}
//     >
//       <Container
//         sx={{
//           flexGrow: 1,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           paddingTop: "30px",
//         }}
//       >
//         <Card
//           sx={{
//             minWidth: 400,
//             maxWidth: 600,
//             borderRadius: 3,
//             boxShadow: 4,
//             padding: 3,
//             textAlign: "center",
//           }}
//         >
//           <CardContent
//             sx={{
//               backgroundColor: msgObj[status]?.color || "#fbc02d",
//               color: "#fff",
//               padding: "24px",
//               borderRadius: "8px",
//             }}
//           >
//             {status === "checking" ? (
//               <CircularProgress color="inherit" size={50} />
//             ) : status === "success" ? (
//               <CheckCircleIcon sx={{ fontSize: 50, color: "#fff" }} />
//             ) : (
//               <ErrorIcon sx={{ fontSize: 50, color: "#fff" }} />
//             )}
//             <Typography variant="h5" fontWeight="bold" sx={{ marginTop: 2 }}>
//               {msgObj[status]?.message || "Checking services..."}
//             </Typography>
//             <Typography
//               variant="h7"
//               align="center"
//               sx={{ marginBottom: "20px" }}
//             >
//               Services({services.filter((s) => s.status).length}/
//               {services.length})
//             </Typography>
//           </CardContent>
//         </Card>

//         {failedServices.length > 0 && (
//           <TableContainer component={Paper} sx={{ mt: 3, maxWidth: 600 }}>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell align="left" sx={{ fontWeight: "bold" }}>
//                     Service Name
//                   </TableCell>
//                   <TableCell align="center" sx={{ fontWeight: "bold" }}>
//                     Status
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {failedServices.map((service) => (
//                   <TableRow key={service.name}>
//                     <TableCell align="left">{service.name}</TableCell>
//                     <TableCell align="center" sx={{ color: "#d32f2f" }}>
//                       Down
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </Container>
//       <Box
//         component="footer"
//         sx={{ bgcolor: "#eeeeee", py: 2, textAlign: "center" }}
//       >
//         <Typography variant="body2" color="textSecondary">
//           @ {new Date().getFullYear()} Unify.Care - All Rights Reserved.
//         </Typography>
//       </Box>
//     </Box>
//   );
// }
import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Container,
  CircularProgress,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

export default function ServiceStatus() {
  const [status, setStatus] = useState("checking");

  const apiUrls = [
    "https://api.unify.care/api/workos/health",
    "https://api.unify.care/api/account/health",
    "https://api.unify.care/api/administration/health",
    "https://api.unify.care/api/order/health",
    "https://api.unify.care/api/diagnostic/health",
    "https://api.unify.care/api/fhir/health",
    "https://api.unify.care/api/billing/health",
    "https://api.unify.care/api/payment/health",
    "https://api.unify.care/api/ipd/health",
    "https://api.unify.care/api/pharmacy/health",
    "https://api.unify.care/api/translation/health",
    // "https://api.unify.care/api/national-health-api/health",
    "https://api.unify.care/api/abdm/health",
    "https://api.unify.care/api/healtharticle/health",
    // "https://api.unify.care/api/inventory/health",
    // "https://admin.unify.care/healths",
    // "https://patient.unify.care/healths",
    // "https://accounts.unify.care/healths",
    // `https://practitioner.unify.care/healths`,
    // `https://studio.unify.care/healths`,
    // `https://inventory.unify.care/healths`,
    // `https://central.unify.care/healths`,
    // `https://unify.care/healths`,

  ];

  const msgObj = {
    checking: {
      message: "Checking services...",
      color: "#fbc02d",
    },
    success: {
      message: "Environment is stable",
      color: "#19706e",
    },
    failure: {
      message: "Environment is not stable",
      color: "#d32f2f",
    },
  };

  const checkServices = async () => {
    try {
      const results = await Promise.allSettled(
        apiUrls.map(async (url) => {
          const res = await fetch(url, { cache: "no-store" });
          return res.status === 200;
        })
      );

      const successfulChecks = results.filter(
        (result) => result.status === "fulfilled" && result.value
      ).length;

      setStatus(successfulChecks === apiUrls.length ? "success" : "failure");
    } catch (error) {
      setStatus("failure");
    }
  };

  useEffect(() => {
    checkServices();

    const interval = setInterval(() => {
      checkServices();
    }, 600000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
      }}
    >
      <Container
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "30px",
        }}
      >
        <Card
          sx={{
            minWidth: 400,
            maxWidth: 600,
            borderRadius: 3,
            boxShadow: 4,
            padding: 3,
            textAlign: "center",
          }}
        >
          <CardContent
            sx={{
              backgroundColor: msgObj[status]?.color || "#fbc02d",
              color: "#fff",
              padding: "24px",
              borderRadius: "8px",
            }}
          >
            {status === "checking" ? (
              <CircularProgress color="inherit" size={50} />
            ) : status === "success" ? (
              <CheckCircleIcon sx={{ fontSize: 50, color: "#fff" }} />
            ) : (
              <ErrorIcon sx={{ fontSize: 50, color: "#fff" }} />
            )}
            <Typography variant="h5" fontWeight="bold" sx={{ marginTop: 2 }}>
              {msgObj[status]?.message || "Checking services..."}
            </Typography>
          </CardContent>
        </Card>
      </Container>
      <Box
        component="footer"
        sx={{ bgcolor: "#eeeeee", py: 2, textAlign: "center" }}
      >
        <Typography variant="body2" color="textSecondary">
          @ {new Date().getFullYear()} Unify.Care - All Rights Reserved.
        </Typography>
      </Box>
    </Box>
  );
}
